var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup39(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 165.71,
    height: 110.79,
    viewBox: "0 0 165.71 110.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(592.772 -1595.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M504.4,620.079A15.977,15.977,0,1,1,488.424,604.1,15.977,15.977,0,0,1,504.4,620.079",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M488.424,645.151A25.072,25.072,0,1,1,513.5,620.079a25.1,25.1,0,0,1-25.072,25.072m0-45.683a20.611,20.611,0,1,0,20.611,20.611,20.634,20.634,0,0,0-20.611-20.611",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M618.563,630.579H539.4a10.5,10.5,0,0,1,0-21h79.161a10.5,10.5,0,0,1,0,21",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M504.4,680.725a15.977,15.977,0,1,1-15.977-15.977A15.977,15.977,0,0,1,504.4,680.725",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M488.424,705.8A25.072,25.072,0,1,1,513.5,680.725,25.1,25.1,0,0,1,488.424,705.8m0-45.683a20.611,20.611,0,1,0,20.611,20.611,20.634,20.634,0,0,0-20.611-20.611",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M618.563,691.225H539.4a10.5,10.5,0,0,1,0-21h79.161a10.5,10.5,0,0,1,0,21",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup39);
export default __webpack_public_path__ + "static/media/Group 39.aec302c0fa13a16961aec99613a3accc.svg";
export { ForwardRef as ReactComponent };